import { useEffect, useState } from "react";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { createCode } from "../actions/other/clientsActions";
import { AppDispatch, RootState } from "../store";
import ReceiptList from "./ReceiptList";
import Loader from "../components/loaders/Loader";
import AppNavbar from "../components/menus/AppNavbar";

const RECEIPT_SESSION_KEY = 'receiptSession'
const SESSION_DURATION = 10 * 60 * 1000 // 10 minutos

export default function ReceiptIdentification() {
    const { t } = useTranslation()
    const dispatch: AppDispatch = useDispatch()
    const [dni, setDni] = useState<string>('')
    const [code, setCode] = useState<string>('')
    const [codeSent, setCodeSent] = useState<boolean>(false)
    const [verified, setVerified] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)
    const { resultclient, loading } = useSelector((state: RootState) => state.clients)
    const { resultreceipt } = useSelector((state: RootState) => state.receipts)

    // Al cargar, comprobamos si hay una sesión válida en localStorage
    useEffect(() => {
        dispatch({ type: 'CLIENT_RESET_RESULT' })

        try {
            const raw = localStorage.getItem(RECEIPT_SESSION_KEY)
            if (raw) {
                const session = JSON.parse(raw)
                if (session?.code && session?.expiresAt > Date.now()) {
                    setCode(session.code)
                    setVerified(true)
                } else {
                    localStorage.removeItem(RECEIPT_SESSION_KEY)
                }
            }
        } catch {
            localStorage.removeItem(RECEIPT_SESSION_KEY)
        }
    }, [])

    useEffect(() => {
        if (!resultclient) return
        if (resultclient === 'codesuccess') {
            setError(null)
            setCodeSent(true)
        } else {
            setError(resultclient)
        }
        dispatch({ type: 'CLIENT_RESET_RESULT' })
    }, [resultclient, dispatch])

    useEffect(() => {
        if (!resultreceipt) return
        if (resultreceipt !== 'codesuccess') {
            setError(resultreceipt)
            setVerified(false)
        }
        dispatch({ type: 'RECEIPT_RESET_RESULT' })
    }, [resultreceipt, dispatch])

    const handleSubmitDni = async (event: any) => {
        event.preventDefault()
        dispatch(createCode(dni) as any)
    }

    const handleSubmitCode = async (event: any) => {
        event.preventDefault()
        // Guardamos la sesión en localStorage al verificar el código
        localStorage.setItem(RECEIPT_SESSION_KEY, JSON.stringify({
            code,
            expiresAt: Date.now() + SESSION_DURATION
        }))
        setVerified(true)
    }

    const handleExpired = () => {
        localStorage.removeItem(RECEIPT_SESSION_KEY)
        setVerified(false)
        setCode('')
        setCodeSent(false)
    }

    return (
        <>
            <AppNavbar />
            <Container className='contenido' style={{ marginTop: 120 }}>
                <Row>
                    <Col className='mt-3 px-1'>
                        <Row>
                            <Col xs={12}>
                                <h1>{t('menus.personalReceiptManagement')}</h1>
                            </Col>
                        </Row>
                        {loading
                            ?
                            <Loader />
                            :
                            <>
                                <Row>
                                    <Col xs={12} className='my-3 px-1'>
                                        {verified
                                            ?
                                            <ReceiptList code={code} onExpired={handleExpired} />
                                            :
                                            <Card>
                                                <Card.Body className='p-5'>
                                                    {!codeSent ? (
                                                        <Form onSubmit={handleSubmitDni}>
                                                            <Row>
                                                                <Col xs={12} className='my-3'>
                                                                    <Form.Label>{t("global.dni")} ({t('global.mandatory')})</Form.Label>
                                                                    <Form.Control
                                                                        type='text'
                                                                        name='dni'
                                                                        value={dni}
                                                                        onChange={(e) => setDni(e.target.value)}
                                                                        required
                                                                    />
                                                                </Col>
                                                            </Row>
                                                            {error && (
                                                                <Row>
                                                                    <Col xs={12} className='my-2'>
                                                                        <p className="text-danger mb-0">{error === 'clientNotFound' ? t('clientTranslate.clientNotFound') : t('serverError')}</p>
                                                                    </Col>
                                                                </Row>
                                                            )}
                                                            <Row>
                                                                <Col xs={12} md={6} className='my-3 ms-auto text-end'>
                                                                    <Button type="submit" variant="primary" className='width-300'>
                                                                        {t("global.send")}
                                                                    </Button>
                                                                </Col>
                                                            </Row>
                                                        </Form>
                                                    ) : (
                                                        <Form onSubmit={handleSubmitCode}>
                                                            <Row>
                                                                <Col xs={12} className='my-3'>
                                                                    <Form.Label>{t("global.code")} ({t('global.mandatory')})</Form.Label>
                                                                    <Form.Control
                                                                        type='text'
                                                                        name='code'
                                                                        value={code}
                                                                        onChange={(e) => setCode(e.target.value)}
                                                                        required
                                                                    />
                                                                </Col>
                                                            </Row>
                                                            {error && (
                                                                <Row>
                                                                    <Col xs={12} className='my-2'>
                                                                        <p className="text-danger mb-0">{error === 'invalidCode' ? t('receiptTranslate.invalidCode') : t('serverError')}</p>
                                                                    </Col>
                                                                </Row>
                                                            )}
                                                            <Row>
                                                                <Col xs={12} md={6} className='my-3 ms-auto text-end'>
                                                                    <Button type="submit" variant="primary" className='width-300'>
                                                                        {t("global.verify")}
                                                                    </Button>
                                                                </Col>
                                                            </Row>
                                                        </Form>
                                                    )}
                                                </Card.Body>
                                            </Card>
                                        }
                                    </Col>
                                </Row>
                            </>
                        }
                    </Col>
                </Row>
            </Container>
        </>
    )
}